
import React from 'react';

interface SectionWrapperProps {
  children: React.ReactNode;
  id?: string;
  index: number;
  activeIndex: number;
}

const SectionWrapper: React.FC<SectionWrapperProps> = ({ children, id, index, activeIndex }) => {
  let stateClass = 'is-future';
  if (index === activeIndex) {
    stateClass = 'is-present';
  } else if (index < activeIndex) {
    stateClass = 'is-past';
  }

  return (
    <div 
      id={id}
      className={`page-section h-screen w-full overflow-hidden ${stateClass}`}
    >
      <div className="page-content h-full w-full">
        {children}
      </div>
    </div>
  );
};

export default SectionWrapper;
